// extracted by mini-css-extract-plugin
export default {"skChase":"Spinner_skChase__lLBz2","sk-chase":"Spinner_sk-chase__MbibG","skChaseDot":"Spinner_skChaseDot__x-85Y","skChaseDotBefore":"Spinner_skChaseDotBefore__UiatJ"};